









import { Vue, Prop, Component } from "vue-property-decorator"

@Component({})
export default class RelatedRecipeList extends Vue {
	@Prop({ required: true }) recipe!: RecipeObject;
}
